import React from 'react';
import Fade from 'react-reveal/Fade';
import squarel from '../Assets/squarel.png';
import brush from '../Assets/brush.png'

const Productc = () => {
  return (
    <div className='about-section-container'>
      <Fade right>
        <div className="right-about-background-image-container">
        <img src={squarel} alt="" />
        </div>
      </Fade>
        <div className="right-home-text-section">
        <Fade left>
        <h1 className="product-primary-heading">
            Bamboo Toothbrush
        </h1>
        <p className="product-primary-text">
            €3.59
        </p>
      </Fade>
        <Fade bottom>
        <div className='about-buttons-container'>
          <button className="secondary-button">Buy Now</button>
        </div>
      </Fade>
        </div>
        <Fade right>
        <div className="right-about-section-image-container">
        <img className='image' src={brush} alt="" />
        </div>
      </Fade>
    </div>
  )
}

export default Productc